import { render } from "./component-payer-korr-acc.vue?vue&type=template&id=43a2d73d"
import script from "./component-payer-korr-acc.vue?vue&type=script&setup=true&lang=js"
export * from "./component-payer-korr-acc.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-payer-korr-acc.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43a2d73d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43a2d73d', __exports__)) {
    api.reload('43a2d73d', __exports__)
  }
  
  module.hot.accept("./component-payer-korr-acc.vue?vue&type=template&id=43a2d73d", () => {
    api.rerender('43a2d73d', render)
  })

}


export default __exports__